import { render, staticRenderFns } from "./MainNavigation.vue?vue&type=template&id=5173e686&scoped=true"
import script from "./MainNavigation.vue?vue&type=script&lang=js"
export * from "./MainNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5173e686",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5173e686')) {
      api.createRecord('5173e686', component.options)
    } else {
      api.reload('5173e686', component.options)
    }
    module.hot.accept("./MainNavigation.vue?vue&type=template&id=5173e686&scoped=true", function () {
      api.rerender('5173e686', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/posts/components/MainNavigation.vue"
export default component.exports